!function (e) {
  function n(e) {
    return RegExp("(\\()(?:" + e + ")(?=[\\s\\)])");
  }

  function a(e) {
    return RegExp("([\\s([])(?:" + e + ")(?=[\\s)])");
  }

  var t = "(?!\\d)[-+*/~!@$%^=<>{}\\w]+",
      r = "(\\()",
      i = "(?:[^()]|\\((?:[^()]|\\((?:[^()]|\\((?:[^()]|\\((?:[^()]|\\([^()]*\\))*\\))*\\))*\\))*\\))*",
      s = {
    heading: {
      pattern: /;;;.*/,
      alias: ["comment", "title"]
    },
    comment: /;.*/,
    string: {
      pattern: /"(?:[^"\\]|\\.)*"/,
      greedy: !0,
      inside: {
        argument: /[-A-Z]+(?=[.,\s])/,
        symbol: RegExp("`" + t + "'")
      }
    },
    "quoted-symbol": {
      pattern: RegExp("#?'" + t),
      alias: ["variable", "symbol"]
    },
    "lisp-property": {
      pattern: RegExp(":" + t),
      alias: "property"
    },
    splice: {
      pattern: RegExp(",@?" + t),
      alias: ["symbol", "variable"]
    },
    keyword: [{
      pattern: RegExp("(\\()(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)(?=\\s)"),
      lookbehind: !0
    }, {
      pattern: RegExp("(\\()(?:append|by|collect|concat|do|finally|for|in|return)(?=\\s)"),
      lookbehind: !0
    }],
    declare: {
      pattern: n("declare"),
      lookbehind: !0,
      alias: "keyword"
    },
    interactive: {
      pattern: n("interactive"),
      lookbehind: !0,
      alias: "keyword"
    },
    boolean: {
      pattern: a("nil|t"),
      lookbehind: !0
    },
    number: {
      pattern: a("[-+]?\\d+(?:\\.\\d*)?"),
      lookbehind: !0
    },
    defvar: {
      pattern: RegExp("(\\()def(?:const|custom|group|var)\\s+" + t),
      lookbehind: !0,
      inside: {
        keyword: /^def[a-z]+/,
        variable: RegExp(t)
      }
    },
    defun: {
      pattern: RegExp("(\\()(?:cl-)?(?:defmacro|defun\\*?)\\s+" + t + "\\s+\\(" + i + "\\)"),
      lookbehind: !0,
      greedy: !0,
      inside: {
        keyword: /^(?:cl-)?def\S+/,
        arguments: null,
        function: {
          pattern: RegExp("(^\\s)" + t),
          lookbehind: !0
        },
        punctuation: /[()]/
      }
    },
    lambda: {
      pattern: RegExp("(\\()lambda\\s+\\(\\s*(?:&?" + t + "(?:\\s+&?" + t + ")*\\s*)?\\)"),
      lookbehind: !0,
      greedy: !0,
      inside: {
        keyword: /^lambda/,
        arguments: null,
        punctuation: /[()]/
      }
    },
    car: {
      pattern: RegExp(r + t),
      lookbehind: !0
    },
    punctuation: [/(?:['`,]?\(|[)\[\]])/, {
      pattern: /(\s)\.(?=\s)/,
      lookbehind: !0
    }]
  },
      l = {
    "lisp-marker": RegExp("&(?!\\d)[-+*/~!@$%^=<>{}\\w]+"),
    varform: {
      pattern: RegExp("\\(" + t + "\\s+(?=\\S)" + i + "\\)"),
      inside: s
    },
    argument: {
      pattern: RegExp("(^|[\\s(])" + t),
      lookbehind: !0,
      alias: "variable"
    },
    rest: s
  },
      o = "\\S+(?:\\s+\\S+)*",
      p = {
    pattern: RegExp(r + i + "(?=\\))"),
    lookbehind: !0,
    inside: {
      "rest-vars": {
        pattern: RegExp("&(?:body|rest)\\s+" + o),
        inside: l
      },
      "other-marker-vars": {
        pattern: RegExp("&(?:aux|optional)\\s+" + o),
        inside: l
      },
      keys: {
        pattern: RegExp("&key\\s+" + o + "(?:\\s+&allow-other-keys)?"),
        inside: l
      },
      argument: {
        pattern: RegExp(t),
        alias: "variable"
      },
      punctuation: /[()]/
    }
  };
  s.lambda.inside.arguments = p, s.defun.inside.arguments = e.util.clone(p), s.defun.inside.arguments.inside.sublist = p, e.languages.lisp = s, e.languages.elisp = s, e.languages.emacs = s, e.languages["emacs-lisp"] = s;
}(Prism);